import { Component, Input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ProjectCreatorService } from '../../../../client/services/project-creator.service';
import { StylePicker } from '../../../../../shared/components/products/style-picker/style-picker';
import { I18nService } from '../../../../../shared/services/i18n.service';
import { MainStyleDto } from '../../../../../core/api/_dtos/projects.dto';
import { AppButton } from '../../../../client/components/atom/app-button/app-button';

@Component({
  selector: 'app-style-section',
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    StylePicker,
    AppButton
  ],
  templateUrl: './style-section.html',
  styleUrl: './style-section.scss',
  host: {
    '[class.style-section-creative]': 'variant === "creative"'
  }
})
export class StyleSection {
  @Input() variant: 'default' | 'creative' = 'default';

  readonly defaultPreviewImage = '/assets/imgs/dog.png';
  selectedStyle = signal<MainStyleDto | null>(null);

  constructor(
    private projectCreatorService: ProjectCreatorService,
    private router: Router,
    private i18n: I18nService
  ) {
  }

  get showHeader(): boolean {
    return this.variant === 'default';
  }

  onStyleSelected(style: MainStyleDto | null): void {
    this.selectedStyle.set(style);
    if (style) {
      this.projectCreatorService.setStyle(style);
    }
  }

  fileChangeEvent(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;
    const file = input.files[0];
    this.projectCreatorService.setImage(file);
    input.value = '';
    const url = this.i18n.generateUrlWithLang('/project');
    this.router.navigate([url], {
      queryParams: {
        styleId: this.selectedStyle()?.id,
        flow: 'creative',
      },
    });
  }
}
